// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* light theme */

  /* dark theme tokens */
  --primary-bg-dark: 33, 35, 37;
  --secondary-bg-dark: 46, 53, 61;
  --tertiary-bg-dark: 66, 75, 86;

  --border-dark: 65, 69, 79;

  --placeholder-primary-dark: 255, 255, 255;
  --placeholder-secondary-dark: 148, 163, 184;
  --placeholder-tertiary-dark: 138, 151, 170;

  --accent-brand-dark: 0, 122, 255;
  --accent-warning-dark: 251, 146, 60;
  --accent-error-dark: 255, 28, 69;
  --accent-success-dark: 16, 185, 129;
  --accent-waiting-dark: 37, 99, 235;
}

[data-theme='light'] {
  --primary-bg: var(--primary-bg-dark);
  --secondary-bg: var(--secondary-bg-dark);
  --tertiary-bg: var(--tertiary-bg-dark);

  --placeholder-primary: var(--placeholder-primary-dark);
  --placeholder-secondary: var(--placeholder-secondary-dark);
  --placeholder-tertiary: var(--placeholder-tertiary-dark);

  --accent-brand: var(--accent-brand-dark);
  --accent-warning: var(--accent-warning-dark);
  --accent-error: var(--accent-error-dark);
  --accent-success: var(--accent-success-dark);
  --accent-waiting: var(--accent-waiting-dark);
}

[data-theme='dark'] {
  --primary-bg: var(--primary-bg-dark);
  --secondary-bg: var(--secondary-bg-dark);
  --tertiary-bg: var(--tertiary-bg-dark);

  --placeholder-primary: var(--placeholder-primary-dark);
  --placeholder-secondary: var(--placeholder-secondary-dark);
  --placeholder-tertiary: var(--placeholder-tertiary-dark);

  --accent-brand: var(--accent-brand-dark);
  --accent-warning: var(--accent-warning-dark);
  --accent-error: var(--accent-error-dark);
  --accent-success: var(--accent-success-dark);
  --accent-waiting: var(--accent-waiting-dark);

  --border: var(--border-dark)
}`, "",{"version":3,"sources":["webpack://./src/styles/themes.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;;EAEhB,sBAAsB;EACtB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;;EAE9B,yBAAyB;;EAEzB,yCAAyC;EACzC,2CAA2C;EAC3C,0CAA0C;;EAE1C,gCAAgC;EAChC,mCAAmC;EACnC,gCAAgC;EAChC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,sCAAsC;;EAEtC,sDAAsD;EACtD,0DAA0D;EAC1D,wDAAwD;;EAExD,wCAAwC;EACxC,4CAA4C;EAC5C,wCAAwC;EACxC,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,sCAAsC;;EAEtC,sDAAsD;EACtD,0DAA0D;EAC1D,wDAAwD;;EAExD,wCAAwC;EACxC,4CAA4C;EAC5C,wCAAwC;EACxC,4CAA4C;EAC5C,4CAA4C;;EAE5C;AACF","sourcesContent":[":root {\n  /* light theme */\n\n  /* dark theme tokens */\n  --primary-bg-dark: 33, 35, 37;\n  --secondary-bg-dark: 46, 53, 61;\n  --tertiary-bg-dark: 66, 75, 86;\n\n  --border-dark: 65, 69, 79;\n\n  --placeholder-primary-dark: 255, 255, 255;\n  --placeholder-secondary-dark: 148, 163, 184;\n  --placeholder-tertiary-dark: 138, 151, 170;\n\n  --accent-brand-dark: 0, 122, 255;\n  --accent-warning-dark: 251, 146, 60;\n  --accent-error-dark: 255, 28, 69;\n  --accent-success-dark: 16, 185, 129;\n  --accent-waiting-dark: 37, 99, 235;\n}\n\n[data-theme='light'] {\n  --primary-bg: var(--primary-bg-dark);\n  --secondary-bg: var(--secondary-bg-dark);\n  --tertiary-bg: var(--tertiary-bg-dark);\n\n  --placeholder-primary: var(--placeholder-primary-dark);\n  --placeholder-secondary: var(--placeholder-secondary-dark);\n  --placeholder-tertiary: var(--placeholder-tertiary-dark);\n\n  --accent-brand: var(--accent-brand-dark);\n  --accent-warning: var(--accent-warning-dark);\n  --accent-error: var(--accent-error-dark);\n  --accent-success: var(--accent-success-dark);\n  --accent-waiting: var(--accent-waiting-dark);\n}\n\n[data-theme='dark'] {\n  --primary-bg: var(--primary-bg-dark);\n  --secondary-bg: var(--secondary-bg-dark);\n  --tertiary-bg: var(--tertiary-bg-dark);\n\n  --placeholder-primary: var(--placeholder-primary-dark);\n  --placeholder-secondary: var(--placeholder-secondary-dark);\n  --placeholder-tertiary: var(--placeholder-tertiary-dark);\n\n  --accent-brand: var(--accent-brand-dark);\n  --accent-warning: var(--accent-warning-dark);\n  --accent-error: var(--accent-error-dark);\n  --accent-success: var(--accent-success-dark);\n  --accent-waiting: var(--accent-waiting-dark);\n\n  --border: var(--border-dark)\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
